"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vizportal_webclient_api_1 = require("@tableau/vizportal-webclient-api");
var PageParams_1 = require("./types/PageParams");
var FilterParams_1 = require("./types/FilterParams");
var OrderParams_1 = require("./types/OrderParams");
var GetUsersMethod_1 = require("@tableau/vizportal-webclient-api/lib/api/methods/GetUsersMethod");
var VerifyNamedSharingIsValidForUserMethod_1 = require("@tableau/vizportal-webclient-api/lib/api/methods/VerifyNamedSharingIsValidForUserMethod");
var ServerFactory_1 = require("./ServerFactory");
var ShareContentMethod_1 = require("@tableau/vizportal-webclient-api/lib/api/methods/ShareContentMethod");
var ApiService = /** @class */ (function () {
    function ApiService() {
    }
    ApiService.searchUser = function (userQueryText) {
        var _this = this;
        var requestParams = this.getSearchUserRequestParams(userQueryText);
        var wrappedRequester = ServerFactory_1.ServerFactory.Instance.getWrappedRequester();
        var getUsers = wrappedRequester.createSender(GetUsersMethod_1.GetUsersMethod);
        // Request users from server
        return getUsers(requestParams).then(function (resp) {
            // If the request was successful, then it doesn't mean that users are returned
            // It is possible that in response we have errors.
            // Here we are calling getSuccessResult to get successful results from the getUsers response.
            // If there are errors in response, then getSuccessResult will reject the promise.
            return vizportal_webclient_api_1.getSuccessResult(resp).
                then(function (searchResults) {
                // Response has user search results. Return to the client.
                return Promise.resolve(searchResults);
            }, function (errorJSON) {
                // There were errors in successful reponse. Returns the first error code, if exists, to requester.
                return Promise.reject(_this.getErrorCodeFromResponse(errorJSON.response));
            });
        }, function (error) {
            return Promise.reject(_this.getErrorCodeFromErrors(error.errors));
        });
    };
    ApiService.getSearchUserRequestParams = function (nameQueryText) {
        return {
            filter: FilterParams_1.getSearchUserNameFilterParams(nameQueryText),
            order: OrderParams_1.getSearchUserOrderParams(),
            page: PageParams_1.getPageParams(0, ApiService.MAX_USER_LIST_COUNT)
        };
    };
    ApiService.verifyUser = function (userId) {
        var _this = this;
        var requestParams = { userId: parseInt(userId, 10), };
        var wrappedRequester = ServerFactory_1.ServerFactory.Instance.getWrappedRequester();
        var verify = wrappedRequester.createSender(VerifyNamedSharingIsValidForUserMethod_1.VerifyNamedSharingIsValidForUserMethod);
        return verify(requestParams).then(function (resp) {
            return vizportal_webclient_api_1.getSuccessResult(resp)
                .then(function () {
                // response is empty if successful
                return Promise.resolve();
            }, function (errorJSON) {
                // There were errors in successful reponse. Returns the first error code, if exists, to requester.
                return Promise.reject(_this.getErrorCodeFromResponse(errorJSON.response));
            });
        }, function (error) {
            return Promise.reject(_this.getErrorCodeFromErrors(error.errors));
        });
    };
    /**
    * Some content types exist only on the front end, so map these to their corresponding backend content types
    */
    ApiService.fixContentTypes = function (frontEndContentType) {
        switch (frontEndContentType) {
            case 'recommendedView': return 'view';
            default: return frontEndContentType;
        }
    };
    ApiService.share = function (contentId, contentType, userIds, url, message, shouldShareThumbnail) {
        var _this = this;
        var requestParams = {
            contentId: contentId,
            contentType: contentType,
            recipients: userIds.map(this.userIdToTypedId),
            url: url,
            message: message,
            shouldShareThumbnail: shouldShareThumbnail,
        };
        var wrappedRequester = ServerFactory_1.ServerFactory.Instance.getWrappedRequester();
        var shareContent = wrappedRequester.createSender(ShareContentMethod_1.ShareContentMethod);
        // Map front-end specific contentTypes to backend compatible ones
        requestParams.contentType = this.fixContentTypes(requestParams.contentType);
        // Send request to shareContent API
        return shareContent(requestParams).then(function (resp) {
            return vizportal_webclient_api_1.getSuccessResult(resp).then(function (shareResponse) {
                // Response has lists of recipients. Return to the client.
                return Promise.resolve(shareResponse);
            }, function (errorJSON) {
                // There were errors in successful reponse. Returns the first error code, if exists, to requester.
                return Promise.reject(_this.getErrorCodeFromResponse(errorJSON.response));
            });
        }, function (error) {
            return Promise.reject(_this.getErrorCodeFromErrors(error.errors));
        });
    };
    ApiService.MAX_USER_LIST_COUNT = 10;
    ApiService.userIdToTypedId = function (id) {
        return { type: 'USER', id: id };
    };
    ApiService.getErrorCodeFromErrors = function (errors) {
        return (!!errors && errors.length > 0) ? errors[0].code : undefined;
    };
    ApiService.getErrorCodeFromResponse = function (response) {
        var errors = vizportal_webclient_api_1.getErrors(response);
        return ApiService.getErrorCodeFromErrors(errors);
    };
    return ApiService;
}());
exports.ApiService = ApiService;
//# sourceMappingURL=ApiService.js.map